import React from 'react';

import { GetServerSidePropsContext } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { KeyActive, NewsLayout, PageLayout, PagePath } from '@/layouts/shared';
import withAuthServerSideProps from '@/libs/auth';
import { fetchBlogs, fetchNews, fetchNewsBySlug } from '@/features/blog/api';
import { EmagazineArticleLayout, IArticle, IRelatedProduct, PromotionsArticleLayout } from '@/features/article';
import { fetchProductsByIds } from '@/features/products/list/api';

const BlogPage = ({ article, products, newArticles, blogs }: IArticle) => {
  if (article.acf.layout === NewsLayout.PromotionsLayout)
    return <PromotionsArticleLayout article={article} products={products} newArticles={newArticles} blogs={blogs} />;
  return <EmagazineArticleLayout article={article} products={products} newArticles={newArticles} blogs={blogs} />;
};

export const getServerSideProps = withAuthServerSideProps(
  async ({ locale, query }: GetServerSidePropsContext) => {
    try {
      const { id } = query;
      const { data } = await fetchNewsBySlug(id + '');
      const article = data[0];
      let products: IRelatedProduct[] = [];
      if (article.acf.related_products) {
        const { data: relatedProducts } = await fetchProductsByIds(article.acf.related_products);
        products = relatedProducts;
      }
      const { data: newArticles } = await fetchNews({ page: 1, per_page: 5 });
      const { data: blogs } = await fetchBlogs();
      return {
        props: {
          article,
          layout: PageLayout.New,
          keyActive: KeyActive.News,
          products,
          newArticles,
          blogs,
          ...(await serverSideTranslations(locale as string, ['layout', 'product'])),
        },
      };
    } catch (_) {
      return {
        redirect: {
          permanent: false,
          destination: PagePath.HomePage,
        },
      };
    }
  },
  { isAntiAuth: false, isPublic: true }
);
export default BlogPage;
